export const event = (action, category, label, value) => {
    window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value: value,
    });
};
export const reportConversion = (sendTo, url) => {
    window.gtag("event", "conversion", {
        send_to: sendTo,
        event_callback: () => {
            if (url !== undefined) {
                window.location = url;
            }
        },
    });
    return false;
};
//# sourceMappingURL=gtag.js.map